import { t } from "@lingui/core/macro";

import { Button } from "@whoosh/design-system/src/components/controls";
import { CloseIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Text,
  Box,
  HStack,
} from "@whoosh/design-system/src/components/primitive";

export const DiningSpecialRequestModalHeader = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  return (
    <HStack
      alignItems="center"
      flexGrow={1}
      justifyContent="space-between"
      paddingBottom={5}
    >
      <Button
        variant="secondary"
        testID="dining-special-requests-modal-header-close-button"
        size="small"
        leftIcon={<CloseIcon />}
        onPress={onClose}
        accessibilityLabel={t`Close`}
      />
      <Text variant="mainBaseSemiBold" flex={1} textAlign="center">
        {t`Special Requests`}
      </Text>
      <Box width={8} />
    </HStack>
  );
};
